export const ALARM_EMAIL_ROUTING_ACTION = {
  // List (one GET returns settings + holidays + mode, §5 combined payload)
  GET_ALARM_EMAIL_ROUTING_SETTINGS: 'GET_ALARM_EMAIL_ROUTING_SETTINGS',
  GET_ALARM_EMAIL_ROUTING_SETTINGS_SUCCESS:
    'GET_ALARM_EMAIL_ROUTING_SETTINGS_SUCCESS',
  GET_ALARM_EMAIL_ROUTING_SETTINGS_ERROR:
    'GET_ALARM_EMAIL_ROUTING_SETTINGS_ERROR',

  // Create one SETTING| item
  CREATE_ALARM_EMAIL_ROUTING_SETTING: 'CREATE_ALARM_EMAIL_ROUTING_SETTING',
  CREATE_ALARM_EMAIL_ROUTING_SETTING_SUCCESS:
    'CREATE_ALARM_EMAIL_ROUTING_SETTING_SUCCESS',
  CREATE_ALARM_EMAIL_ROUTING_SETTING_ERROR:
    'CREATE_ALARM_EMAIL_ROUTING_SETTING_ERROR',
  CREATE_ALARM_EMAIL_ROUTING_SETTING_CLEAN_STATE:
    'CREATE_ALARM_EMAIL_ROUTING_SETTING_CLEAN_STATE',

  // Full-replace one SETTING| item (settingId in body)
  UPDATE_ALARM_EMAIL_ROUTING_SETTING: 'UPDATE_ALARM_EMAIL_ROUTING_SETTING',
  UPDATE_ALARM_EMAIL_ROUTING_SETTING_SUCCESS:
    'UPDATE_ALARM_EMAIL_ROUTING_SETTING_SUCCESS',
  UPDATE_ALARM_EMAIL_ROUTING_SETTING_ERROR:
    'UPDATE_ALARM_EMAIL_ROUTING_SETTING_ERROR',
  UPDATE_ALARM_EMAIL_ROUTING_SETTING_CLEAN_STATE:
    'UPDATE_ALARM_EMAIL_ROUTING_SETTING_CLEAN_STATE',

  // Delete one SETTING| item by settingId
  DELETE_ALARM_EMAIL_ROUTING_SETTING: 'DELETE_ALARM_EMAIL_ROUTING_SETTING',
  DELETE_ALARM_EMAIL_ROUTING_SETTING_SUCCESS:
    'DELETE_ALARM_EMAIL_ROUTING_SETTING_SUCCESS',
  DELETE_ALARM_EMAIL_ROUTING_SETTING_ERROR:
    'DELETE_ALARM_EMAIL_ROUTING_SETTING_ERROR',
  DELETE_ALARM_EMAIL_ROUTING_SETTING_CLEAN_STATE:
    'DELETE_ALARM_EMAIL_ROUTING_SETTING_CLEAN_STATE',

  // Replace-all user holiday dates
  UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS: 'UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS',
  UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS_SUCCESS:
    'UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS_SUCCESS',
  UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS_ERROR:
    'UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS_ERROR',
  UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS_CLEAN_STATE:
    'UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS_CLEAN_STATE',

  // Test-mail send (テスト送信) to the destinations in the form — no
  // persistence, so no CLEAN_STATE: the sendingTest flag is reset on
  // SUCCESS/ERROR directly.
  SEND_TEST_NOTIFICATION: 'SEND_TEST_NOTIFICATION',
  SEND_TEST_NOTIFICATION_SUCCESS: 'SEND_TEST_NOTIFICATION_SUCCESS',
  SEND_TEST_NOTIFICATION_ERROR: 'SEND_TEST_NOTIFICATION_ERROR',

  // Per-company cutover mode (§9)
  UPDATE_ALARM_EMAIL_ROUTING_MODE: 'UPDATE_ALARM_EMAIL_ROUTING_MODE',
  UPDATE_ALARM_EMAIL_ROUTING_MODE_SUCCESS:
    'UPDATE_ALARM_EMAIL_ROUTING_MODE_SUCCESS',
  UPDATE_ALARM_EMAIL_ROUTING_MODE_ERROR:
    'UPDATE_ALARM_EMAIL_ROUTING_MODE_ERROR',
};

// =========================================================================
// List alarm email routing settings (+ holidays + mode)
export const getAlarmEmailRoutingSettings = () => ({
  type: ALARM_EMAIL_ROUTING_ACTION.GET_ALARM_EMAIL_ROUTING_SETTINGS,
});

// data: { settings: [], holidays: [], mode: 'SHADOW' | 'LIVE' }
export const getAlarmEmailRoutingSettingsSuccess = (data) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.GET_ALARM_EMAIL_ROUTING_SETTINGS_SUCCESS,
  payload: data,
});

export const getAlarmEmailRoutingSettingsError = ({ message }) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.GET_ALARM_EMAIL_ROUTING_SETTINGS_ERROR,
  payload: message,
});

// =========================================================================
// Create a routing setting
// data: { name, enabled, destinations, targetGroupIds, sendConditions }
export const createAlarmEmailRoutingSetting = (data) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.CREATE_ALARM_EMAIL_ROUTING_SETTING,
  payload: data,
});

export const createAlarmEmailRoutingSettingSuccess = (data) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.CREATE_ALARM_EMAIL_ROUTING_SETTING_SUCCESS,
  payload: data,
});

export const createAlarmEmailRoutingSettingError = ({ message }) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.CREATE_ALARM_EMAIL_ROUTING_SETTING_ERROR,
  payload: message,
});

export const createAlarmEmailRoutingSettingCleanState = () => ({
  type: ALARM_EMAIL_ROUTING_ACTION.CREATE_ALARM_EMAIL_ROUTING_SETTING_CLEAN_STATE,
});

// =========================================================================
// Update (full-replace) a routing setting — settingId travels in the body
export const updateAlarmEmailRoutingSetting = (data) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_SETTING,
  payload: data,
});

export const updateAlarmEmailRoutingSettingSuccess = (data) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_SETTING_SUCCESS,
  payload: data,
});

export const updateAlarmEmailRoutingSettingError = ({ message }) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_SETTING_ERROR,
  payload: message,
});

export const updateAlarmEmailRoutingSettingCleanState = () => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_SETTING_CLEAN_STATE,
});

// =========================================================================
// Delete a routing setting by settingId (string)
export const deleteAlarmEmailRoutingSetting = (settingId) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.DELETE_ALARM_EMAIL_ROUTING_SETTING,
  payload: settingId,
});

export const deleteAlarmEmailRoutingSettingSuccess = (settingId) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.DELETE_ALARM_EMAIL_ROUTING_SETTING_SUCCESS,
  payload: settingId,
});

export const deleteAlarmEmailRoutingSettingError = ({ message }) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.DELETE_ALARM_EMAIL_ROUTING_SETTING_ERROR,
  payload: message,
});

export const deleteAlarmEmailRoutingSettingCleanState = () => ({
  type: ALARM_EMAIL_ROUTING_ACTION.DELETE_ALARM_EMAIL_ROUTING_SETTING_CLEAN_STATE,
});

// =========================================================================
// Replace-all user holiday dates
// dates: ['YYYY-MM-DD', ...]
export const updateAlarmEmailRoutingHolidays = (dates) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS,
  payload: dates,
});

export const updateAlarmEmailRoutingHolidaysSuccess = (dates) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS_SUCCESS,
  payload: dates,
});

export const updateAlarmEmailRoutingHolidaysError = ({ message }) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS_ERROR,
  payload: message,
});

export const updateAlarmEmailRoutingHolidaysCleanState = () => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_HOLIDAYS_CLEAN_STATE,
});

// =========================================================================
// Test-mail send (テスト送信) — data: { destinations: ['a@…', …] }
export const sendTestNotification = (data) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.SEND_TEST_NOTIFICATION,
  payload: data,
});

export const sendTestNotificationSuccess = () => ({
  type: ALARM_EMAIL_ROUTING_ACTION.SEND_TEST_NOTIFICATION_SUCCESS,
});

export const sendTestNotificationError = ({ message }) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.SEND_TEST_NOTIFICATION_ERROR,
  payload: message,
});

// =========================================================================
// Set the per-company cutover mode (§9)
// mode: 'SHADOW' | 'LIVE'
export const updateAlarmEmailRoutingMode = (mode) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_MODE,
  payload: mode,
});

export const updateAlarmEmailRoutingModeSuccess = (mode) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_MODE_SUCCESS,
  payload: mode,
});

export const updateAlarmEmailRoutingModeError = ({ message }) => ({
  type: ALARM_EMAIL_ROUTING_ACTION.UPDATE_ALARM_EMAIL_ROUTING_MODE_ERROR,
  payload: message,
});
